import { render } from "./ResetPassword.vue?vue&type=template&id=55f7c13d"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"
script.render = render

export default script